/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import useTranslate from 'hooks/useTranslate';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import { Box, Container } from '@material-ui/core';
import PageContainer from 'components/PageContainer';
import SkipPrefillButton from 'features/SkipPrefillButton';
import Link from 'components/Link';
import styles from './styles';
import useWorkflow, { Step } from 'hooks/useWorkflow';
import CancelButton from 'features/CancelButton';
import ActionButtonContainer from 'components/ActionButtonsContainer';
import { contentContainer } from 'features/Theme/mixins';

const ErrorView: React.FC = () => {
  const { pathAfter } = useWorkflow();
  const t = useTranslate();
  const tMd = useMarkdownTranslate();
  return (
    <Box css={contentContainer}>
      <PageContainer>
        <h1 css={styles.headerTitle}>{tMd('batchPrescreen.error.title')}</h1>

        <Container maxWidth="sm">
          <Box my={3}>
            <p
              css={styles.body}
              dangerouslySetInnerHTML={{
                __html: t('batchPrescreen.error.message'),
              }}
            />
          </Box>
          <ActionButtonContainer>
            <SkipPrefillButton
              variant="contained"
              id="continueToApplication"
              component={Link}
              to={pathAfter(Step.BATCH_PRESCREEN_START)}
            >
              {t('batchPrescreen.error.continueButton')}
            </SkipPrefillButton>

            <CancelButton />
          </ActionButtonContainer>
        </Container>
      </PageContainer>
    </Box>
  );
};

export default ErrorView;
